// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreBrowseNavigation = (client) => ({
    /**
     * `GET /store/browse-navigation`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreGetBrowseNavigation
     * @source packages/modules/b2c-core/src/api/store/browse-navigation/route.ts
     */
    list: (query, headers) => client.fetch("/store/browse-navigation", { method: "GET", query, headers }),
    /**
     * `GET /store/browse-navigation/applications/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreGetBrowseNavigationApplication
     * @source packages/modules/b2c-core/src/api/store/browse-navigation/applications/[id]/route.ts
     */
    retrieveApplication: (id, query, headers) => client.fetch(buildPath("/store/browse-navigation/applications/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /store/browse-navigation/suggest`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreGetBrowseNavigationSuggest
     * @source packages/modules/b2c-core/src/api/store/browse-navigation/suggest/route.ts
     */
    suggest: (query, headers) => client.fetch("/store/browse-navigation/suggest", { method: "GET", query, headers }),
});
//# sourceMappingURL=browse-navigation.js.map